/** @deprecated https://github.com/remo-co/remo-conference/issues/6956 */
type Browser = "Chrome" | "Safari" | "Firefox" | "Edge";

/** @deprecated https://github.com/remo-co/remo-conference/issues/6956 */
export const browserNames: Record<string, Browser> = {
  CHROME: "Chrome",
  SAFARI: "Safari",
  FIREFOX: "Firefox",
  EDGE: "Edge",
};

/** @deprecated https://github.com/remo-co/remo-conference/issues/6956 */
export type OSName = "macOS" | "windows" | "iOS" | "Android";

/** @deprecated https://github.com/remo-co/remo-conference/issues/6956 */
export const OSNames: Record<string, OSName> = {
  MAC: "macOS",
  WINDOWS: "windows",
  IOS: "iOS",
  ANDROID: "Android",
};
